import 'vue2-datepicker/index.css';

import Vue from 'vue';
import DatePicker from 'vue2-datepicker';

Vue.use(DatePicker);
